// eslint-disable-next-line max-classes-per-file
export class ValidationError extends Error {}
export class NotFoundError extends Error {}
export class MethodNotAllowed extends Error {}
export class InternalServerError extends Error {}
export class UnprocessableEntityError extends Error {}
export class UnauthorizedError extends Error {}
export class Forbidden extends Error {}
export class OauthAuthorizeError extends Error {}
